import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** ヘッダ行の設定 */
enum CsvColumnSettingMethod {
  fixedColumn = '1',
  autoDetect = '2',
}

const nameConfig = {
  fixedColumn: new Map([[Locale.ja, '固定列: 標準定義の列順でデータを取り込みます。']]),
  autoDetect: new Map([[Locale.ja, '自由列: ヘッダ名で項目を識別してデータを取り込みます。']]),
};

const toEnum = rawValueToEnum(CsvColumnSettingMethod, CsvColumnSettingMethod.fixedColumn);
const toDisplay = enumToName(CsvColumnSettingMethod, nameConfig);
const toDisplayWithPrefix = enumToName(CsvColumnSettingMethod, nameConfig, { prefix: true });

export const csvColumnSettingMethod = {
  enum: CsvColumnSettingMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { CsvColumnSettingMethod };
